import { Fragment, useRef } from "react"
import { Outlet } from "react-router"
import Header from "../component/Header";
import Footer from "../component/Footer";
import { useGaTag } from "../libs/ga";
import { useTrackregisterBtn } from "../App";

export const Layout = () => {
    useGaTag();
    // useTrackregisterBtn();
    const myRef = useRef(null);
    const executeScroll = () => myRef.current.scrollIntoView();
    return (
    <Fragment>
        <Header executeScroll={executeScroll} />
        <Outlet />
        <Footer />
    </Fragment>
    )
}